const fb = require('../firebase.js');
class Message {
    constructor(id, content, fullDate, fullName, mail, sujet) {
        this.id = id
        this.content = content
        this.fullDate = fullDate
        this.fullName = fullName
        this.mail = mail
        this.sujet = sujet
    }
    async ajoutMessage() {
        delete this.id
        return await fb.db.collection('messages').add({ ...this });
    }
    async deleteMessage() {
        return await fb.db.collection('messages').doc(this.id).delete();
    }
}

module.exports = { Message };